export default "__VITE_ASSET__BIAcS6V1__"